import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DonationModal from '../components/DonationModal';
import SEO from '../components/SEO';
import './DonativosPage.css';

const DonativosPage = () => {
  const [showDonationModal, setShowDonationModal] = useState(false);

  return (
    <div className="donativos-page" data-testid="donativos-page">
      <SEO 
        title="Donativos"
        description="Apoie a AASPS com o seu donativo. O seu contributo faz a diferença na vida de quem mais precisa e permite-nos continuar a promover a saúde mental na comunidade."
        keywords="donativos, donativo, apoiar, AASPS, solidariedade, contribuir"
        url="/donativos"
      />
      <Header />
      
      <div className="donativos-hero">
        <div className="donativos-hero-overlay" />
        <div className="donativos-hero-content">
          <h1>Ajude-nos</h1>
          <p>O seu contributo faz a diferença na vida de quem mais precisa</p>
        </div>
      </div>

      <section className="donativos-content">
        <div className="donativos-container">
          <div className="donativos-intro">
            <h2>Apoie a nossa missão</h2>
            <p>A AASPS é uma Instituição Particular de Solidariedade Social que trabalha diariamente para promover a saúde mental e o bem-estar na comunidade. O seu donativo permite-nos continuar a desenvolver projetos de inclusão social, apoio psicológico e atividades comunitárias.</p>
          </div>

          <div className="donativos-options">
            <div className="donativo-card">
              <h3>Donativo Pontual</h3>
              <p>Contribua com um valor único para apoiar as nossas atividades.</p>
              <button 
                className="donativo-btn"
                onClick={() => setShowDonationModal(true)}
                data-testid="donate-btn"
              >
                Fazer Donativo
              </button>
            </div>

            <div className="donativo-card">
              <h3>Transferência Bancária</h3>
              <p>Pode também fazer o seu donativo por transferência bancária:</p>
              <div className="bank-info">
                <p><strong>Titular:</strong> Associação de Apoio e Segurança Psico-social</p>
                <p><strong>Conta:</strong> 0707001999530</p>
                <p><strong>NIB:</strong> 0035 0707 00001999530 81</p>
                <p><strong>IBAN:</strong> PT50 0035 0707 00001999530 81</p>
                <p><strong>BIC/SWIFT:</strong> CGDIPTPL</p>
              </div>
            </div>
          </div>

          <div className="donativos-info">
            <h3>Benefícios Fiscais</h3>
            <p>Os donativos à AASPS são dedutíveis em sede de IRS ou IRC, nos termos do Estatuto dos Benefícios Fiscais. Após a realização do donativo, emitimos um recibo para efeitos fiscais.</p>
          </div>
        </div>
      </section>

      <Footer />
      
      )}

      <DonationModal 
        isOpen={showDonationModal} 
        onClose={() => setShowDonationModal(false)} 
      />
    </div>
  );
};

export default DonativosPage;
